import { lazyNamed } from "src/utils/lazy-named";
import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";

const CreateJourneyModal = lazyNamed(
  () => import("./components/create-journey-modal"),
  "CreateJourneyModal",
);
const JourneyCanvasTab = lazyNamed(
  () => import("./detail-tabs/journey-canvas-tab"),
  "JourneyCanvasTab",
);
const JourneyMessagesTab = lazyNamed(
  () => import("./detail-tabs/journey-messages-tab"),
  "JourneyMessagesTab",
);
const JourneyRunLogTab = lazyNamed(
  () => import("./detail-tabs/journey-run-log-tab"),
  "JourneyRunLogTab",
);
const JourneyDetailLoader = lazyNamed(
  () => import("./journey-detail"),
  "JourneyDetailLoader",
);
const JourneyTemplateDetailLoader = lazyNamed(
  () => import("./journey-detail"),
  "JourneyTemplateDetailLoader",
);
const journeysImport = () => import("./journeys");
const JourneysLayout = lazyNamed(journeysImport, "JourneysLayout");

export const preloads: RoutePreload[] = [["/journeys", journeysImport]];

export const routes: Array<RouteObject> = [
  {
    path: "journeys",
    spacesAccess: "hidden-from-limited-view",
    element: <JourneysLayout />,
    children: [
      {
        path: "new",
        spacesAccess: "hidden-from-limited-view",
        element: <CreateJourneyModal isOpen />,
      },
    ],
  },
  {
    path: "journeys/:id",
    spacesAccess: "hidden-from-limited-view",
    element: <JourneyDetailLoader />,
    children: [
      {
        index: true,
        element: <Navigate to="canvas" replace />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "canvas",
        element: <JourneyCanvasTab />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "messages",
        element: <JourneyMessagesTab />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "runs",
        element: <JourneyRunLogTab />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
  {
    path: "templates/journeys/:template_id",
    spacesAccess: "hidden-from-limited-view",
    element: <JourneyTemplateDetailLoader />,
    children: [
      {
        index: true,
        element: <Navigate to="canvas" replace />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "canvas",
        element: <JourneyCanvasTab />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
];
